module.exports = __webpack_public_path__ + "img/mail.c1aec212.svg";